import React from "react";
import {connect} from "react-redux";
import {Dimensions, FlatList, Modal, ScrollView, StyleSheet, Text, TouchableOpacity, View} from "react-native";
import FermerPicto from "../../Picto/FermerPicto";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {getAllContact} from "../../../API/API";
import SharePostItem from "./SharePostItem";
import BoutonGenerale from "../../Bouton/BoutonGenerale";

const {width,heigth} = Dimensions.get('screen');

class SharePost extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            modalVisible:false,
            contacts : [],
            selected : []
        }
        this.setSelectedValue = this.setSelectedValue.bind(this);
    }

    componentDidMount() {

    }

    setSelectedValue(element,add){
        const selected = this.state.selected;

        if(add){
            selected.push(element);
        }else{
            selected.remove(element);
        }
        this.setState({
            selected : selected
        })
    }



    render() {

        const styles = StyleSheet.create({
            container:{
                maxHeight:"80%",
            },
            container2:{
                backgroundColor:"red",
                justifyContent:"flex-end",
            },
            popinHeader:{
                flexDirection : "row",
                padding:22,
                paddingBottom:15,
                alignItems:"center",
                borderBottomWidth:1,
                borderBottomColor:this.props.theme.colors.tertiary.black13.value
            },
            text:{
                fontFamily : this.props.theme.fonts.title,
                color: this.props.theme.colors.tertiary.black1.value,
                fontSize:16,
                width:"90%",
                textAlign:"center"
            },
            v:{

            },
            view:{
                backgroundColor:this.props.theme.colors.primary.White.value,
                justifyContent:"flex-start",
                height:"87vh",
                position:"absolute",
                bottom:0,
                width:width,
                borderRadius : 12
            },
            view2:{
                flex:1,
                justifyContent:"flex-start",
                backgroundColor:"rgba(0,0,0,0.5)",
                width:width,
                borderRadius : 12
            }
        })

        return (
            <View style={styles.container2}>

                <Modal style={styles.container2} transparent={true} animationType={'slide'} visible={this.props.modalVisible}
                       onRequestClose={() => {
                       }}>
                    <View style={styles.view2}>
                        <View style={styles.view}>
                            <View style={styles.popinHeader}>
                                <TouchableOpacity onPress={()=>{this.props.setModalVisible(!this.props.modalVisible)}} >
                                    <FermerPicto style={{width:15,height:15}} isHeader={true} />
                                </TouchableOpacity>
                                <Text style={styles.text}>{this.props.t('Partager par message privé')}</Text>
                            </View>
                            <ScrollView
                                style={styles.container}>
                                {this.props.contacts.map((item, i)=>{

                                    return <SharePostItem key={i} setSelectedValue={this.setSelectedValue} contact={item} selected={this.state.selected} />
                                })}
                            </ScrollView>
                            <BoutonGenerale  onPress={()=>{this.props.sendMessage(this.state.selected);this.setState({selected:[]})}} title={this.props.t("Envoyer")} isActivate={true} size={"medium"} hasBorder={false}/>
                        </View>
                    </View>
                </Modal>
            </View>
        );
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer};
}

export default compose(withTranslation(),connect(mapStateToProps))(SharePost);
